import { useQuery } from "@apollo/client";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import "../../App.css";
import { currencyFormat } from "../../Function/DynamicFn";
import { GET_RENT_MATERIAL_REPORT } from "../../Schema/Report";
import { EmptyTr } from "../Include/EmptyData";
import { LoadingTr } from "../Include/LoadingPage";

export default function ReportRentMaterial({
  startDate,
  endDate,
  meterialId,
  warehouseValId,
  studentId,
  unitListId,
}) {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  useQuery(GET_RENT_MATERIAL_REPORT, {
    variables: {
      warehouseIds: warehouseValId ? [warehouseValId] : [],
      materialIds: meterialId ? meterialId : [],
      listMaterialUnitIds: [],
      from: startDate ? dayjs(startDate)?.format("YYYY-MM-DD") : "",
      to: endDate ? dayjs(endDate)?.format("YYYY-MM-DD") : "",
      studentId: studentId ? studentId : null,
      unitIds: unitListId ? unitListId : [],
    },
    onCompleted: ({ getRentMaterialReport }) => {
      // console.log("getRentMaterialReport:::", getRentMaterialReport);
      setTableData(getRentMaterialReport);
      setLoading(false);

      if (getRentMaterialReport?.length > 0) {
        let total = 0;
        getRentMaterialReport?.map((row) => {
          total += row?.qty;
        });
        setTotalAmount(total);
      } else {
        setTotalAmount(0);
      }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    setLoading(true);
  }, [startDate, endDate, meterialId, warehouseValId, studentId, unitListId]);

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        marginTop="25px"
      >
        <Typography className="report-title-kh">របាយការជួលសម្ភារៈ</Typography>
        <Typography className="report-title-en">
          {`${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")}`}
        </Typography>
      </Stack>
      <div className="report-table-scroll-container">
        <table className="report-table">
          <tbody className="report-table-thead">
            <tr>
              <td className="report-table-th" width="2%">
                ល.រ
              </td>
              <td className="report-table-th">កាលបរិច្ឆេទ</td>
              <td className="report-table-th">ឈ្មោះសិស្ស</td>
              <td className="report-table-th">ឈ្មោះអ្នកទទួល</td>
              <td className="report-table-th">ឃ្លាំង</td>
              <td className="report-table-th">បរិយាយ</td>
              <td className="report-table-th">ខ្នាត</td>
              <td className="report-table-th">ចំនួន</td>
              <td className="report-table-th">កាលបរិច្ឆេទត្រូវសង</td>
              {/* <th
                className="first-table-head-text" 
                style={{ fontWeight: "bold" }}
              >
                សរុប
              </th>  */}
            </tr>
          </tbody>

          <tbody className="report-table-body">
            {loading ? (
              <LoadingTr colSpan={9} />
            ) : !tableData?.length ? (
              <EmptyTr colSpan={9} />
            ) : (
              tableData?.map((row, index) => {
                return (
                  <tr key={index}>
                    <td className="report-table-body-td-center">{index + 1}</td>
                    <td className="report-table-body-td-center">
                      {moment(row?.rentMaterialId?.dateTime)?.format(
                        "DD-MM-YYYY hh:mm a",
                      )}
                    </td>
                    <td className="report-table-body-td-left">
                      {row?.rentMaterialId?.studentId?.lastName +
                        " " +
                        row?.rentMaterialId?.studentId?.firstName}{" "}
                      - {row?.rentMaterialId?.studentId?.englishName}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.rentBy}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.warehouseId?.warehouseName}
                    </td>

                    <td className="report-table-body-td-left">
                      {row?.listMaterialUnitId?.materialId?.materialKhName}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.listMaterialUnitId?.unitId?.unitKhName}
                    </td>

                    <td className="report-table-body-td-center">{row?.qty}</td>

                    <td className="report-table-body-td-center">
                      {moment(row?.dueDate)?.format("DD-MM-YYYY")}
                    </td>
                  </tr>
                );
              })
            )}

            <tr>
              <td
                colSpan={7}
                className="report-table-tbody-td-total-total"
              ></td>
              <td className="report-table-tbody-td-total-total" align="center">
                សរុប
              </td>

              <td
                className="report-table-tbody-td-total-cost"
                align="center"
                style={{ fontWeight: "bold" }}
              >
                {currencyFormat(totalAmount?.toFixed(2))}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
